import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  HookLoaderTripsReport,
  ZoneWiseHookLoaderTripsReport,
} from "../../../../Apis/ttrReportsApi";
import TableComponent from "../../../../Common/TableComponent/tableComponent";
import * as XLSX from "xlsx";
import CustomDataTable from "../../../../Common/ReportTable/ReportTable";
import { useNavigate } from "react-router-dom";
import ExcelJS from "exceljs";
import isGHMC from "../../../../Common/helper/helpar";
import { getNowDateTime, getOneMonthPastDateTime } from "../../../AssetVehicle/utils/helpers";
import Loader from "../../../../Common/Loader/loader";

const HookLoaderReport = ({ t }) => {
  const HookLoaderFromDate = localStorage.getItem("HookLoaderFromDate");
  const HookLoaderToDate = localStorage.getItem("HookLoaderToDate");
  // const headers = ["zone", "totalHookLoaders", "totaltrip"];
  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    HookLoaderFromDate || getStartOfCurrentDate()
  );
  const [endDate, setEndDate] = useState(
    HookLoaderToDate || getCurrentDateTime()
  );
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const navigate = useNavigate();
  const isProd = isGHMC();
  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate);
  }, []);

  const fetchTripsTonnageData = async (startDate, endDate) => {
    try {
      setIsLoading(true);
      const response = await HookLoaderTripsReport(startDate, endDate);
      const modifiedResponse = response.data.map((item) => ({
        ...item,
        zone: item.zoneName,
      }));
      setAllTripsTonnage(modifiedResponse);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(startDate, endDate);
  };

  const hookloaderColumns = [
    {
      name: "S.No",
      width: "10%",
      selector: (row) => row["slno"],
      //    sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      //   sortable: true,
      cell: (row) => (
        <span
          style={{ color: `${row.zoneName === "Total"?"black":"blue"}`, cursor: "pointer" }}
          onClick={() =>row.zoneName != "Total"&&handleZoneClick(row)}
        >
          {row["zoneName"]}
        </span>
      ),
    },
    {
      name: "No.of Vehicles",
      selector: (row) => row["numberOfVehicle"],
      cell: (row) => (
        <span
        //  style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleTotalCircleVehicleClick(row["circleId"])}
        >
          {" "}
          {row["numberOfVehicle"]}
        </span>
      ),
      //     sortable: true,
    },
    {
      name: "No.of Trips",
      selector: (row) => row["numberOfTrips"],
      cell: (row) => (
        <span
        //  style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleCondemnedCircleClick(row["circleId"])}
        >
          {row["numberOfTrips"]}
        </span>
      ),
      //     sortable: true,
    },
    {
      name: "Total QTY(MT)",
      selector: (row) => row["totalQty"],
      cell: (row) => (
        <span
        //  style={{ color: "blue", cursor: "pointer" }}
        //  onClick={() => handleUnderRepaiCircleClick(row["circleId"])}
        >
          {row["totalQty"].toFixed(2)}
        </span>
      ),
      //   sortable: true,
    },
  ];

  const handleZoneClick = async (zone) => {
    try {
      setIsLoading(true);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
      };
      const response = await ZoneWiseHookLoaderTripsReport(
        startDate,
        endDate,
        requestData.zoneId
      );
      navigate("/zone-hookloader_report", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

    const downloadHookLoaderAsExcel = async () => {
      // Create a new workbook and add a worksheet
      const currentDate = new Date();
      const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
      const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
      const downloadDateTime = `Hookloader Report Generated on: ${formattedDate}, ${formattedTime}`;
      
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Hookloader Report");
  
      // Define styles
      const boldFont = { bold: true };
  
      // Add the downloadDateTime to the correct row and columns, and ensure formatting
      worksheet.addRow(["", "", downloadDateTime, ""]);
      worksheet.mergeCells(1, 2, 1, 4);
      worksheet.getCell(1, 2).value = downloadDateTime;
      worksheet.getCell(1, 2).font = boldFont;
      worksheet.getCell(1, 2).alignment = { horizontal: "center" };
  
      // Apply styles to the merged cells (B1, C1, D1)
      for (let col = 2; col <= 4; col++) {
          worksheet.getCell(1, col).font = boldFont;
          worksheet.getCell(1, col).alignment = { horizontal: "center" };
      }
  
      // Add "Hookloader Details" to the correct row and columns, and ensure formatting
      worksheet.addRow(["", "", "Hookloader Details", ""]);
      worksheet.mergeCells(2, 2, 2, 4);
      worksheet.getCell(2, 2).value = "Hookloader Details";
      worksheet.getCell(2, 2).font = boldFont;
      worksheet.getCell(2, 2).alignment = { horizontal: "center" };
  
      // Apply styles to the merged cells (B2, C2, D2)
      for (let col = 2; col <= 4; col++) {
          worksheet.getCell(2, col).font = boldFont;
          worksheet.getCell(2, col).alignment = { horizontal: "center" };
      }
  
      // Add table header row with bold font
      const tableHeaderRow = worksheet.addRow([
          "S.No",
          "Zone",
          "No.of vehicles",
          "No.of Trips",
          "Total QTY",
      ]);
      tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.font = boldFont;
          cell.alignment = { horizontal: "left" };
          if (colNumber >= 1 && colNumber <= 6) {
              cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "F6B1B1" },
                  bgColor: { argb: "FFFFFFFF" },
              };
          }
      });
  
      // Add data rows
      let totalVehicles = 0;
      let totalTrips = 0;
      let totalQty = 0;
  
      getAllTripsTonnage.forEach((item, index) => {
          totalVehicles += item.numberOfVehicle;
          totalTrips += item.numberOfTrips;
          totalQty += item.totalQty;
  
          worksheet.addRow([
              index + 1,
              item.zoneName?? "N/A",
              item.numberOfVehicle?? "N/A",
              item.numberOfTrips?? "N/A",
              item.totalQty?? "N/A",
          ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
              if (colNumber >= 1 && colNumber <= 5) {
                  cell.alignment = { horizontal: "left" };
              } else {
                  cell.alignment = { horizontal: "center" };
              }
          });
      });
  
      // Add total row
      const totalRow = worksheet.addRow([
        "",
          'Total',
          totalVehicles,
          totalTrips,
          totalQty,
      ]);
      
      totalRow.eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "left" };
      });
  
      // Set column widths dynamically based on content
      worksheet.columns = [
          { width: 5 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 15 },
      ];
  
      // Save the workbook to a file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "hookloader_report.xlsx";
      a.click();
      URL.revokeObjectURL(url);
  };
  

  const calculateHookloaderTotals = (data) => {
    const totals = {
      sno: "Total",
      zoneName: "Total",
      numberOfVehicle: 0,
      numberOfTrips: 0,
      totalQty: 0,
    };

    data.forEach((row) => {
      totals.numberOfVehicle += row.numberOfVehicle || 0;
      totals.numberOfTrips += row.numberOfTrips || 0;
      totals.totalQty += row.totalQty || 0;
    });
    return totals;
  };

  const totalZoneRow = calculateHookloaderTotals(getAllTripsTonnage);
  const HookloaderDataWithTotal = [...getAllTripsTonnage, totalZoneRow];
  return (
    <>
      {isLoading && <Loader />}
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">Hookloader TTR Report</h4>
            <div className="card">
              <div className="card-body p-3">
                {/* <span style={{ display: "flex-Start" }}><h5>Hook Loader TTR Report</h5></span> */}
                <div className="row align-items-end ">
                  <div className="col-md-10">
                    <form onSubmit={handleFormSubmit}>
                      <div className="row" style={{ textAlign: "left" }}>
                        <div className="col-md-3 ">
                          <label>From Date & Time:</label>
                          <input
                            type="datetime-local"
                            name="FromDate"
                            style={inputStyle}
                            value={startDate}
                            className="form-control"
                            min={getOneMonthPastDateTime()}
                            max={getNowDateTime()}                        
                            onChange={(e) => {
                              setStartDate(e.target.value);
                              localStorage.setItem(
                                "HookLoaderFromDate",
                                e.target.value
                              );
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>To Date & Time:</label>
                          <input
                            type="datetime-local"
                            name="ToDate"
                            style={inputStyle}
                            value={endDate}
                            className="form-control"
                            min={startDate}
                            max={getCurrentDateTime()}
                            onChange={(e) => {
                              setEndDate(e.target.value);
                              localStorage.setItem(
                                "HookLoaderToDate",
                                e.target.value
                              );
                            }}
                          />
                        </div>
                        <div className="col-md-3 ">
                          <button
                            className={`btn mt-4 mr-2 ${
                              isProd ? "search-ghmc" : "search-swm"
                            }`}
                            type="submit"
                          >
                            Search
                          </button>
                          <button
                            className={`btn mt-4 ${
                              isProd ? "search-ghmc" : "search-swm"
                            }`}
                            onClick={() => {
                              localStorage.removeItem("HookLoaderFromDate");
                              localStorage.removeItem("HookLoaderToDate");
                              setStartDate(getStartOfCurrentDate());
                              setEndDate(getStartOfCurrentDate());
                            }}
                            type="submit"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="col-md-2">
                    <div className="text-end  mt-4">
                      <button
                        className="btn btn-excel ms-auto"
                        onClick={downloadHookLoaderAsExcel}
                      >
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                        Excel
                      </button>
                    </div>
                  </div>
                </div>

                <div className="mt-3"></div>
                <CustomDataTable
                  data={HookloaderDataWithTotal}
                  columns={hookloaderColumns}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {};

const buttonStyle = {};

export default withTranslation()(HookLoaderReport);
